import { Injectable } from "@angular/core";
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService, Loader,NgxUiLoaderConfig } from 'ngx-ui-loader';


@Injectable({
    providedIn: 'root'
  })
  export class LoaderService {
   config: NgxUiLoaderConfig;
   constructor(private ngxUiLoaderService: NgxUiLoaderService) {
    this.config = this.ngxUiLoaderService.getDefaultConfig();
    }

   start(id:any){
       this.ngxUiLoaderService.startLoader(id)
   }

   stop(id:any){
       this.ngxUiLoaderService.stopLoader(id)
   }

    
  }